import React from "react";
import { RiskLevel, RISK_LEVELS, riskClass } from "../mockData";

const LABEL: Record<RiskLevel, string> = {
  green:  "Low",
  yellow: "Mod.",
  red:    "High",
};

export function RiskBadge({ risk, size = "sm" }: { risk: RiskLevel; size?: "sm" | "md" }) {
  const c = riskClass(risk);
  const meta = RISK_LEVELS.find((r) => r.id === risk)!;
  return (
    <span
      className={[
        "inline-flex items-center gap-1.5 ring-1 rounded-full",
        size === "md" ? "h-7 px-2.5 text-xs" : "h-5 px-2 text-[0.7rem]",
        c.bg, c.text, c.ring,
      ].join(" ")}
      title={meta.hint}
    >
      <span className={`h-2 w-2 rounded-full ${c.dot}`} />
      <span className="font-semibold">{LABEL[risk]} risk</span>
    </span>
  );
}

export function RiskDot({ risk }: { risk: RiskLevel }) {
  const c = riskClass(risk);
  return <span className={`inline-block h-2 w-2 rounded-full ${c.dot}`} />;
}
